import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as Menu from '../../components/menu/constants'
import * as Request from '../../request'
import {ApplicationState} from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

type OnEnter = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onEnter: OnEnter = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER, Request.successConstant(Constants.SUBMIT_NEW_DOMAIN))
    .filter(() => history.location.pathname.startsWith(Menu.ADMIN_DOMAIN_AUTH_URL))
    .map(store.getState)
    .mergeMap(() => [Actions.fetchDomains(), App.updateUrlParams({filter: Utils.getUrlFilter(store.getState())})])

type OnFilterChange = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onFilterChange: OnFilterChange = (action$, store, {history}) =>
  action$.ofType(Constants.CHANGE_VALIDATON_STATUS_FILTER_STATUS)
    .mergeMap(() => [App.updateUrlParams({filter: Utils.getUrlFilter(store.getState())})])

type OnErroredSubmit = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onErroredSubmit: OnErroredSubmit = (action$, store, {history}) =>
  action$.ofType(Request.errorConstant(Constants.SUBMIT_NEW_DOMAIN))
    .filter(() => history.location.pathname.startsWith(Menu.ADMIN_DOMAIN_AUTH_URL))
    .mergeMap(() => [Flash.showFlashError(Constants.SUBMIT_DOMAIN_ERROR)])

type OnDelete = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onDelete: OnDelete = (action$, store, {history}) =>
  action$.ofType(Request.successConstant(Constants.DELETE_DOMAIN))
    .filter(() => history.location.pathname.startsWith(Menu.ADMIN_DOMAIN_AUTH_URL))
    .mergeMap((action: any) =>
              [action.payload.status === 200 ?
                Flash.showFlashMessage(Constants.SENDGRID_DELETE_SUCCESS) :
                Flash.showFlashError(Constants.SENDGRID_DELETE_ERROR)])

type OnErroredDelete = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onErroredDelete: OnErroredDelete = (action$, store, {history}) =>
  action$.ofType(Request.errorConstant(Constants.DELETE_DOMAIN))
    .filter(() => history.location.pathname.startsWith(Menu.ADMIN_DOMAIN_AUTH_URL))
    .mergeMap(() => [Flash.showFlashError(Constants.SENDGRID_DELETE_ERROR)])

type OnNewDomain = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onNewDomain: OnNewDomain = (action$, store, {history}) =>
  action$.ofType(Request.successConstant(Constants.SUBMIT_NEW_DOMAIN))
    .filter(() => history.location.pathname.startsWith(Menu.ADMIN_DOMAIN_AUTH_URL))
    .mergeMap((action: Request.SuccessAction) => [directDomainAPIResponse(action.payload.response.code)])

const directDomainAPIResponse = (statusCode: number) => {
  return statusCode === 200 ? {type: Constants.DOMAIN_CREATED} : Flash.showFlashError(Constants.DOMAIN_NOT_CREATED)
}

type OnVerification = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onVerification: OnVerification = (action$, store, {history}) =>
  action$.ofType(Request.errorConstant(Constants.VERIFY_DOMAIN))
    .filter(() => history.location.pathname.startsWith(Menu.ADMIN_DOMAIN_AUTH_URL))
    .mergeMap((action: Request.SuccessAction) => [Flash.showFlashError(Constants.FAILED_VERIFICATION)])

type Clipboard = ReduxObservable.Epic<Redux.Action, ApplicationState>
const copyToClipboard: Clipboard = (action$, store, {window}) =>
  action$.ofType(Constants.COPY_TO_CLIPBOARD)
  .do((action: Types.CopyAction) => window.navigator.clipboard.writeText(action.options.value))
  .mapTo({type: Constants.COPY_TO_CLIPBOARD_COMPLETE})

export const epic = ReduxObservable.combineEpics(
  onDelete,
  onEnter,
  onErroredDelete,
  onErroredSubmit,
  onVerification,
  copyToClipboard,
  onFilterChange,
  onNewDomain,
)



// WEBPACK FOOTER //
// ./src/pages/domain-authentication/epic.ts